/*!
 * Created by netlogix GmbH & Co. KG
 *
 * @copyright netlogix GmbH & Co. KG
 */

import { createFeatureSelector, createSelector } from '@ngrx/store';
import { VehiclesState } from '@vehicles/store/vehicles.state';

const selectVehiclesState = createFeatureSelector<VehiclesState>('vehicles');

export const getVehicles = createSelector(selectVehiclesState, state => state.vehicles);
export const getCurrentVehicle = createSelector(selectVehiclesState, state => state.currentVehicle);
export const getIsVehicleActionPending = createSelector(selectVehiclesState, state => state.isActionPending);
export const getLicenseClasses = createSelector(selectVehiclesState, state => state.licenseClasses);
